import { AppConfigSchema, type AppConfig, type Theme } from '@avs/contract';

/**
 * localStorage 持久化层。
 * 命名前缀 v0 起统一改用 `avs-`（旧 `las-studio-*` 不兼容也不迁移，反正是 demo 数据）。
 */
const KEYS = {
  config: 'avs-config',
  theme: 'avs-theme',
  collapsed: 'vedesign-sidebar-collapsed', // 跟着设计系统层，不带产品前缀
  onboarded: 'avs-onboarded',
} as const;

export function loadConfig(): AppConfig {
  try {
    const raw = localStorage.getItem(KEYS.config);
    if (!raw) return AppConfigSchema.parse({});
    return AppConfigSchema.parse(JSON.parse(raw));
  } catch {
    return AppConfigSchema.parse({});
  }
}

export function saveConfig(config: AppConfig): void {
  try {
    localStorage.setItem(KEYS.config, JSON.stringify(config));
  } catch {
    /* quota / disabled, swallow */
  }
}

export function loadTheme(): Theme {
  const raw = localStorage.getItem(KEYS.theme);
  if (raw === 'system' || raw === 'light' || raw === 'dark') return raw;
  return 'system';
}

export function saveTheme(theme: Theme): void {
  try { localStorage.setItem(KEYS.theme, theme); } catch { /* noop */ }
}

export function loadCollapsed(): boolean {
  return localStorage.getItem(KEYS.collapsed) === '1';
}

export function saveCollapsed(collapsed: boolean): void {
  try { localStorage.setItem(KEYS.collapsed, collapsed ? '1' : '0'); } catch { /* noop */ }
}

export function loadOnboarded(): boolean {
  return localStorage.getItem(KEYS.onboarded) === '1';
}

export function saveOnboarded(): void {
  try { localStorage.setItem(KEYS.onboarded, '1'); } catch { /* noop */ }
}
